import { useMemo } from 'react';

import {
  ComponentHeightWrapper,
  ComponentInnerWrapper,
} from '../shared/component-height/component-dimensions.style';
import { computePaddingTop } from '../shared/component-height/component-dimension.utils';
import { ZoomComponentTrigger } from 'approot/activity-builder/activity-builder-zoom-component-modal';
import { ZoomComponentModalProps } from 'approot/activity-builder/activity-builder-zoom-component-modal.constants';
import { ComponentActions } from '../components.style';
import { ViewProps } from './gif.constants';
import { ImageContainer } from '../image/image.style';
import { ImageViewFit } from '../image/image-view';
import ComponentPlayPause from 'approot/shared/play-pause/play-pause';
import { usePausePlaySettings } from 'approot/shared/play-pause/play-pause.hooks';
import * as Styled from './gif-view.style';

const GifView = ({
  properties,
  openModal,
}: ViewProps & ZoomComponentModalProps) => {
  const { isPlaying, setIsPlaying } = usePausePlaySettings();
  const hasImages = useMemo(() => {
    return (
      (properties.imageUrls?.length ?? 0) > 0 ||
      (properties.printImageUrls?.length ?? 0) > 0 ||
      !!properties.image?.original
    );
  }, [properties.imageUrls, properties.printImageUrls, properties.image]);

  return (
    <ComponentHeightWrapper
      style={{
        paddingTop: `${computePaddingTop(properties.dimensionData)}%`,
      }}
    >
      <ComponentInnerWrapper>
        <Styled.GifView>
          <ImageContainer $fullBorderRadius>
            <ImageViewFit
              imageUrls={
                isPlaying
                  ? properties.imageUrls || []
                  : properties.printImageUrls || []
              }
              altText={properties.image?.alt || 'animated image'}
            />
          </ImageContainer>
        </Styled.GifView>

        {openModal && hasImages && (
          <ZoomComponentTrigger
            ariaLabel={properties.image?.alt || 'animated image'}
            openModal={openModal}
          />
        )}
        <ComponentActions>
          <ComponentPlayPause
            isPlaying={isPlaying}
            altText={properties.image?.alt}
            onClick={() => setIsPlaying(!isPlaying)}
          />
        </ComponentActions>
      </ComponentInnerWrapper>
    </ComponentHeightWrapper>
  );
};

export default GifView;
